<section class="border-b border-light-grey p-2">
  <div>
    <div class="w-full flex justify-between items-center">
      <div class="flex flex-col">
        <span class="font-medium leading-6">{{ activityTypeLabel() }}</span>
        <span class="text-mid-grey leading-6">{{ dateString }}</span>
      </div>

      <app-button
        variant="secondary"
        text="mehr"
        [small]="true"
        (clicked)="openModal()"
      />
    </div>
  </div>
</section>
